module.exports = __webpack_public_path__ + "img/academy_haw-sm.996ce84e.png";